import React, { useEffect, useState } from "react";
import styles from './ListenAndDragToPutInOrder.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { Button } from "../../components/Button/Button";
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import LessonInstruction from "../../containers/instruction/LessonInstruction";
import { useRegisterProgress } from "../../hooks/useRegisterProgress";
import {shuffleArray} from "../../lib/utils";
import useAudioPlayback from "../../hooks/useAudioPlayback";

const getSortableItemStyle = (item) => {
  return {
    borderColor: typeof item.right == "undefined"
      ? '#fff'
      : item.right
        ? '#329A12'
        : '#E62D43',
    borderWidth: typeof item.right == "undefined" ? '2px' : '2px'
  }
}

const SortableItem = SortableElement(({ value }) =>
  <div
    className={styles.listen_drag_sortable_item_container}
    style={getSortableItemStyle(value)}
  >
    {value.en}
  </div>
);

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul>
      {items.map((value, index) => (
        <SortableItem key={`item-${value.id}`} index={index} value={value} />
      ))}
    </ul>
  );
});

const ListenAndDragToPutInOrder = props => {
  const {
    blockData,
    contentIndex,
    step,
    lessonId,
    totalIndexes,
    audioUrl
  } = props;
  const [items, setItems] = useState([]);
  const [checked, setChecked] = useState(false);
  const [buttonMsg, setButtonMsg] = useState('Check');
  const [solved, setSolved] = useState(false);

  // hook useRegisterProgress
  const { registerProgress } = useRegisterProgress(
    blockData.block_id,
    lessonId,
    blockData.sectionId,
    blockData.section,
    blockData.num,
    totalIndexes,
    "listen_and_drag_to_put_in_order"
  );

  const handleCompleteClick = async () => {
    try {
      await registerProgress();
    } catch (error) {
      console.log("Erro ao registrar progresso: ", error);
    }
  };

  const { state, togglePlayback} = useAudioPlayback();

  const getItems = () => {
    let items = []

    items = blockData.content.filter(a => a.type !== 'instruction').map((item, index) => { // add a sort count for drill types
      item.order = index;
      item.right = undefined;
      return item;
    })

    setItems(shuffleArray(items));
  }

  const checkOrder = () => {
    if (solved) {
      handleCompleteClick();
      step('skipForward');
    }

    if (checked) {
      solve();
      return;
    }

    let checkedItems = items;
    for (let i = 0; i < checkedItems.length; i++) {
      if (checkedItems[i].order !== i) {
        checkedItems[i].right = false;
      } else {
        checkedItems[i].right = true;
      }
    }

    setItems(checkedItems);
    setChecked(true);
    setButtonMsg("Solve");
  }

  const solve = () => {
    let solvedItems = items;

    solvedItems = solvedItems.sort((a, b) => { return a.order - b.order }); // sort by order number

    solvedItems = solvedItems.map(item => { // set all answers as right
      item.right = true;
      return item;
    });

    setItems(solvedItems);
    setSolved(true);
    setButtonMsg("Done");
  }

  useEffect(() => {
    getItems();
  }, []);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setItems(arrayMove(items, oldIndex, newIndex));
  }

  const getImageUrl = (image) => {
    return `${process.env.REACT_APP_CLOUDFRONT_DNS}/media/images/` + image
  }

  const onPlayClick = () => {
      togglePlayback();
  };

  return (
    <div className={styles.default_card + " default-card default-card-full-width"}>
      {
        blockData.content[contentIndex].type === 'instruction' ?
          <>
            <LessonInstruction
              instructionText={blockData.content[contentIndex].instruction}
              audioUrl={audioUrl}
            />
          </>
          :
          <div className={styles.listen_drag_container}>
            <div className={styles.listen_drag_container_image_draggable}>
              <div className={styles.listen_drag_img_audio_text_container}>
                <img
                  className={styles.listen_drag_img}
                  src={getImageUrl(
                    (blockData && blockData.complement && blockData.complement.image && blockData.complement.image.img) ||
                    (blockData && blockData.complement && blockData.complement.img && blockData.complement.img.img)
                  )}
                />
                <div className={styles.listen_drag_audio_text_container}>
                  <Button onClick={() => onPlayClick()} className={styles.listen_drag_audio_icon_container} 
                  style={{ cursor: 'pointer' }} >
                    {state === 'playing' ? (
                      <FontAwesomeIcon icon={faPause} style={{ fontSize: 40 }} />
                    ) : (
                      <FontAwesomeIcon icon={faVolumeUp} style={{ fontSize: 40 }} />
                    )}

                  </Button>

                  <div className={styles.listen_drag_instruction_text}>
                    Listen and put in order
                  </div>
                </div>
              </div>
              <div className={styles.listen_drag_sortable_list_container}>
                <SortableList items={items} onSortEnd={onSortEnd} />
              </div>
            </div>
            <div className={styles.check_btn_container}>
              <button
                className={styles.check_btn}
                onClick={() => {
                  checkOrder()
                }}
              >
                {buttonMsg}
              </button>
            </div>
          </div>
      }
    </div>
  );
}

export default ListenAndDragToPutInOrder;
